import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContinueToNextViewButton } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ContinueToNextViewButton";
import { convertErrorToLoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/convertErrorToLoginError";
import { ErrorMessage } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ErrorMessage";
import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { useSignInEventTracker } from "@faire/retailer-visitor-shared/components/AppSignIn/useSignInEventTracker";
import { handleKeyDown } from "@faire/retailer-visitor-shared/lib/handleKeyDown";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { Input } from "@faire/web--source/slate/Input";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import patchUser from "@faire/web-api--source/api/user/patch";
import React, { useState } from "react";
var INPUT_IDENTIFIER = "password";
export var CreatePasswordView = function(param) {
    var loggedInUser = param.loggedInUser, onComplete = param.onComplete, onLogin = param.onLogin;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(""), 2), password = _useState[0], setPassword = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), error = _useState1[0], setError = _useState1[1];
    var trackFieldValue = useSignInEventTracker("CREATE_PASSWORD").trackFieldValue;
    var onContinue = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        trackEvent("/login-modal/set-password");
                        setError(undefined);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            patchUser({
                                token: loggedInUser.token,
                                password: password
                            })
                        ];
                    case 2:
                        _state.sent();
                        trackEvent("/login-modal/logged-in-after-setting-password");
                        onLogin(loggedInUser);
                        onComplete({
                            nextView: View.LOADING
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setError(convertErrorToLoginError(e, strictLocalize));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onContinue() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(LoginWrapper, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "L8rNwA",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Create a password"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "xwVYsP",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "This will make it easy for you to log into your account in the future"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(Input, {
                autoFocus: true,
                autoComplete: "new-password",
                placeholder: strictLocalize({
                    id: "uUeQfJ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Create Password"
                        }
                    ]
                }),
                name: INPUT_IDENTIFIER,
                type: INPUT_IDENTIFIER,
                role: INPUT_IDENTIFIER,
                value: password,
                onChange: function(event) {
                    setPassword(event.currentTarget.value);
                    trackFieldValue(INPUT_IDENTIFIER, "");
                },
                onKeyDown: handleKeyDown(onContinue)
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            /*#__PURE__*/ _jsx(ContinueToNextViewButton, {
                onClick: onContinue
            }),
            /*#__PURE__*/ _jsx(ErrorMessage, {
                error: error
            })
        ]
    });
};
